var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvativeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 0.799805C6.16093 0.799805 0.799988 6.16075 0.799988 12.7998C0.799988 13.2613 0.835491 13.7229 0.870994 14.1844L21.2142 4.27909C19.084 2.11341 16.1018 0.799805 12.8 0.799805ZM10.4213 24.5513V18.7998H2.36212C4.06626 21.711 6.942 23.8767 10.4213 24.5513ZM22.7053 6.08975L12.516 24.7998C12.6225 24.7998 12.729 24.7998 12.8 24.7998C19.439 24.7998 24.8 19.4389 24.8 12.7998C24.7645 10.3146 24.0544 8.0069 22.7053 6.08975Z",
    fill: "#F15A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 0.799805C6.16093 0.799805 0.799988 6.16075 0.799988 12.7998C0.799988 13.2613 0.835491 13.7229 0.870994 14.1844L21.2142 4.27909C19.084 2.11341 16.1018 0.799805 12.8 0.799805ZM10.4213 24.5513V18.7998H2.36212C4.06626 21.711 6.942 23.8767 10.4213 24.5513ZM22.7053 6.08975L12.516 24.7998C12.6225 24.7998 12.729 24.7998 12.8 24.7998C19.439 24.7998 24.8 19.4389 24.8 12.7998C24.7645 10.3146 24.0544 8.0069 22.7053 6.08975Z",
    stroke: "#F15A22",
    strokeWidth: 0.606639,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvativeLogo);
export default __webpack_public_path__ + "static/media/ovative_logo.97304a71530ed23f8b8e09c29203c180.svg";
export { ForwardRef as ReactComponent };